import React, { useMemo, memo } from 'react';
import { MarkerIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import { WORLD } from '@rsos/reduxDataStore/src/features/gisSearch/constants';
import {
  ResultWrapper,
  StyledPlaceName,
  StyledSecondaryAddr,
  RegionalAddr,
} from '../ConnectedUniversalSearch.styles';

function memoed(prevProps, nextProps) {
  // rerender if mouseCursor is or was aligned with the index

  return !(
    prevProps.index === prevProps.mouseCursor ||
    nextProps.index === nextProps.mouseCursor ||
    prevProps.address.attributes.LongLabel !==
      nextProps.address.attributes.LongLabel
  );
}
const StyledSuggestedAddress = memo(
  ({ address, index, mouseCursor, handleSelectedAddress, isGeocomm }) => {
    const {
      PlaceName,
      StAddr,
      SubAddr,
      City,
      RegionAbbr,
      Postal,
      Loc_name,
      MetroArea,
      Region,
      Zone,
    } = address?.attributes || {};

    /**
     * @constant {Boolean} isGlobalFormat - the check is to determine the UI's output for local geocoder
     * As of right now we have Geocomm and Non-Geocomm (DatamarkGis)
     * Geocomm's local gis response is different than ArcGis's default response
     * Where as Non-Geocomm is/will be following ArcGis's default format
     */
    const isGlobalFormat = useMemo(() => {
      if (isGeocomm) {
        return Loc_name === WORLD;
      }
      return true;
    }, [Loc_name, isGeocomm]);

    let regionalAdd = `${MetroArea}, ${Region} ${Zone}`;

    if (isGlobalFormat) {
      regionalAdd = `${City}, ${RegionAbbr} ${Postal}`;
      if (!City) {
        regionalAdd = `${RegionAbbr} ${Postal}`;
      }
    } else {
      if (!MetroArea) {
        regionalAdd = `${Region} ${Zone}`;
      }
    }
    return (
      <ResultWrapper
        onClick={() => {
          handleSelectedAddress(address);
        }}
        isHovered={mouseCursor === index}
        key={index}
      >
        <Box horizontal p="0" m="0">
          <MarkerIcon width={16} height={16} />
          <Box p="0" m="0">
            {PlaceName && <StyledPlaceName>{PlaceName}</StyledPlaceName>}
            {StAddr && (
              <StyledSecondaryAddr isPrimary={!PlaceName}>
                {StAddr}
              </StyledSecondaryAddr>
            )}
            {SubAddr && (
              <StyledSecondaryAddr isPrimary={!PlaceName && !StAddr}>
                {SubAddr}
              </StyledSecondaryAddr>
            )}
            <Box horizontal>
              <RegionalAddr>{regionalAdd}</RegionalAddr>
            </Box>
          </Box>
        </Box>
      </ResultWrapper>
    );
  },
  memoed,
);

export default StyledSuggestedAddress;
